module.exports = __webpack_public_path__ + "static/media/go_to_bag.7958bb9b.svg";